import React from 'react';
export function OpeningHook() {
  return <section className="bg-white/50 py-16 md:py-24 px-6" data-id="element-113">
      <div className="text-container text-center md:text-left" data-id="element-114">
        <p className="text-xl md:text-2xl leading-relaxed text-charcoal mb-8 font-medium" data-id="element-115">
          Te despiertas sintiéndote "bien", pero a las 4 de la tarde tu abdomen
          parece haber crecido tres tallas. Te sientes pesada, inflamada y, por
          más que intentas comer "saludable" o cerrar la boca, esa grasa
          abdominal simplemente no se mueve.
        </p>
        <div className="w-24 h-1 bg-gold mx-auto md:mx-0 mb-8 rounded-full" data-id="element-116"></div>
        <p className="text-lg md:text-xl leading-relaxed text-charcoal-light" data-id="element-117">
          No es que te falte voluntad. No es que estés comiendo demasiado. Es
          que tu cuerpo ha encendido el{' '}
          <strong className="text-sage-dark font-bold" data-id="element-118">
            "Interruptor de Cortisol"
          </strong>
          , una señal de supervivencia que bloquea tu metabolismo y ensancha tu
          cintura debido a los cambios hormonales de la madurez.
        </p>
      </div>
    </section>;
}